// 权益 UI 配置
import freeLogo from '@/assets/svg/white/member-free.svg';
import proLogo from '@/assets/svg/white/member-pro.svg';
import plusLogo from '@/assets/svg/white/member-plus.svg';
import alphaLogo from '@/assets/svg/white/member-alpha.svg';
export const MEMBER_TYPE_CONFIG = {
  free: {
    logo: freeLogo,
    theme: '#78C8EC',
    color: '#62C8E7',
  },
  pro: {
    logo: proLogo,
    theme: '#6596F8',
    color: '#417FF9',
  },
  plus: {
    logo: plusLogo,
    theme: '#F8BC88',
    color: '#E7A249',
  },
  alpha: {
    logo: alphaLogo,
    theme: '#9695EF',
    color: '#716ECE',
  },
  trial: {
    logo: alphaLogo,
    theme: '#9695EF',
    color: '#716ECE',
  },
};
